export const payments = {
  title: `Paiements`,

  payment_succeed: `Paiments réussis`,
};
